import React from "react";

import { useGetCopilotConfig, useSetCopilotConfig } from "manager/hooks/api/companyQueries";

import CopilotSettings from "./CopilotSettings";

interface CopilotSettingsContainerProps {
  backLink: { to: string; children: string };
}

const CopilotSettingsContainer = ({ backLink }: CopilotSettingsContainerProps) => {
  const { copilotConfig, isCopilotConfigLoading } = useGetCopilotConfig();
  const { setCopilotConfig, isSettingCopilotConfig } = useSetCopilotConfig();

  const handleSubmit = (values: any) => {
    setCopilotConfig(values);
  };

  return (
    <CopilotSettings
      backLink={backLink}
      config={copilotConfig}
      isLoading={isCopilotConfigLoading}
      isSaving={isSettingCopilotConfig}
      onSubmit={handleSubmit}
    />
  );
};

export default CopilotSettingsContainer;
